import { AbstractContentState, useCmsContent } from '@cp-shared-10/frontend-integration';
import { IconFooter } from 'common';
import { fetchIconFooter } from './IconFooterSlice';
import { IconFooterContentSelector } from './IconFooterContentSelector';

export function useIconFooter(): AbstractContentState<IconFooter> {
    return useCmsContent(fetchIconFooter, IconFooterContentSelector);
}
